module.exports = "pegasus/assets/blocks/column-lp14-themelp1.png";